<template>
  <!-- 自定义套餐 -->
  <div v-if="serviceList.length > 0">
    <div class="mt26 comboWrap" :class="{ comboActive: activePkgIndex == -1 }">
      <p class="title" v-if="businessType == 'COMPANY_INCORPORATION'">
        {{ $t("creation.custom") }}
      </p>
      <p class="title" v-if="businessType == 'SERVICE_TRANSFER'">
        {{ $t("creation.customTransfer") }}
      </p>
      <div class="details">
        <p class="price" v-if="selectedServiceList.length > 0">{{ serviceListPriceSum(selectedServiceList, selectedServiceList[0].currency) }}</p>
        <p class="price" v-else>0.00</p>
        <div class="applicability">
          <p class="pt20">{{ $t("creation.crowd") }}</p>
          <p class="lh16 black88 fs12 pt8">
            {{ $t("creation.service") }}
          </p>
        </div>
        <div class="listWrap">
          <div v-if="selectedServiceList.length > 0">
            <p class="name black45 fwb">
              {{ $t("creation.comboInclude") }}
            </p>
            <div>
              <ul>
                <li v-for="item in selectedServiceList" :key="`diy-${item.id}`" class="black45 pt4">
                  <span class="fwb green fs12 el-icon-check"></span>
                  {{ getLanguage == "zh" ? item.descriptionCn : item.description }}
                  <span v-if="$isNumberLike(item.serviceFee)">({{ priceCurrencyFormat(item.serviceFee, item.currency) }})</span>
                  <info-popover
                    placement="top"
                    :content="getLanguage == 'zh' ? item.serviceScopeCn : item.serviceScope"
                    iconClass="fs13 grey"
                    v-if="item.serviceScopeCn && item.serviceScope"
                  />
                </li>
              </ul>
            </div>
            <!-- 第三方费用 -->
            <p class="pt4">
              <span class="fwb green fs12 el-icon-check"></span>
              {{ $t("creation.priceInclude") }}
            </p>
            <ul>
              <li v-for="part in mergeSameAttrList(selectedServiceList, 'thirdPartyFeeDescription', 'thirdPartyFee')" :key="`part-${part.id}`" class="black88 pt4">
                -
                {{ getLanguage == "zh" ? part.thirdPartyFeeDescriptionCn : part.thirdPartyFeeDescription }}
                <span v-if="$isNumberLike(part.thirdPartyFee)">({{ priceCurrencyFormat(part.thirdPartyFee, part.currency) }})</span>
              </li>
            </ul>
            <!-- 其他费用 -->
            <p class="pt4">
              <span class="fwb green fs12 el-icon-check"></span>
              {{ $t("creation.otherExpenses") }}
            </p>
            <ul>
              <li v-for="other in mergeSameAttrList(selectedServiceList, 'otherFeeDescription', 'otherFee')" :key="`other-${other.id}`" class="black88 pt4">
                -
                {{ getLanguage == "zh" ? other.otherFeeDescriptionCn : other.otherFeeDescription }}
                <span v-if="$isNumberLike(other.otherFee)">({{ priceCurrencyFormat(other.otherFee, other.currency) }})</span>
              </li>
            </ul>
          </div>
          <el-button type="text" icon="el-icon-circle-plus-outline" class="pt10 fs12" @click="addServeHandle">{{ $t("creation.select") }}</el-button>
        </div>
      </div>
      <p class="el-icon-success pitch"></p>
    </div>

    <!-- 选择服务弹窗 -->
    <select-service-modal ref="selectServiceModalRef" :country="country" :businessType="businessType" :serviceList="serviceList" @update="updateSelectedServiceList" />
  </div>
</template>

<script>
import { getAction } from "@/api/common";
import SelectServiceModal from "../modal/SelectService";
import formatMixin from "@/mixins/formatMixin";
import priceCountMixin from "@/mixins/priceCountMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [formatMixin, priceCountMixin],
  components: {
    SelectServiceModal,
  },
  props: {
    country: {
      type: String,
      default: "",
    },
    businessType: {
      type: String,
      default: "",
    },
    activePkgIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      serviceList: [], // 服务列表
      selectedServiceList: [], // 选中的服务列表
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
    ...mapGetters("constant", ["getServiceCodeMap"]),
  },
  methods: {
    // 初始化
    init() {
      this.serviceList = [];
      this.selectedServiceList = [];
      this.getServiceList();
    },
    // 获取服务列表
    getServiceList() {
      getAction("/service/getList", {
        country: this.country,
        businessType: this.businessType,
      }).then(res => {
        const resData = res.data || [];
        this.serviceList = resData;
        this.setSelectedServiceList();
      });
    },
    // 根据当前国家和业务类型，来设置自定义套餐中的必选项
    setSelectedServiceList() {
      const mapObj = this.getServiceCodeMap(this.country, this.businessType);
      const requiredServiceCodeList = mapObj?.requiredServiceCodeList || [];
      this.selectedServiceList = this.serviceList.filter(item => requiredServiceCodeList.includes(item.serviceCode));
    },
    // 选择服务
    addServeHandle() {
      this.$refs.selectServiceModalRef.init(this.selectedServiceList);
    },
    // 更新选中的服务列表
    updateSelectedServiceList(selectedList) {
      this.selectedServiceList = selectedList;
      this.$emit("update", selectedList);
    },
    // 向父级组件传递选中的服务列表(由父级触发)
    emitSelectedServiceList() {
      this.$emit("update", this.selectedServiceList);
    },
  },
};
</script>

<style lang="scss" scoped></style>
